import React, { useEffect, useState } from "react";
import { getGoogleAuthStatus, register } from "../services/api";
import apiRoutes from "../services/apiRoutes";

const Register = () => {
    const [formData, setFormData] = useState({ username: "", email: "", password: "" });
    const [errorMessage, setErrorMessage] = useState("");
    const [successMessage, setSuccessMessage] = useState("");
    const [isGoogleAuthEnabled, setIsGoogleAuthEnabled] = useState(false);

    useEffect(() => {
        getGoogleAuthStatus()
            .then(({ data }) => setIsGoogleAuthEnabled(Boolean(data.enabled)))
            .catch(() => setIsGoogleAuthEnabled(false));
    }, []);

    const handleChange = (event) => {
        setFormData({ ...formData, [event.target.name]: event.target.value });
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        const form = new FormData();
        form.append("username", formData.username);
        form.append("email", formData.email);
        form.append("password", formData.password);

        try {
            const { data } = await register(form);
            setSuccessMessage(data.message || "Registration request sent. Wait for approval.");
            setErrorMessage("");
        } catch (err) {
            console.error("Error during registration:", err.response?.data || err);
            setErrorMessage(err.response?.data?.detail || "Registration failed. Please try again.");
        }
    };

    const handleGoogleLogin = () => {
        if (!isGoogleAuthEnabled) {
            setErrorMessage("Google registration is not configured yet. Use username and password.");
            return;
        }

        window.location.href = `${apiRoutes.BASE_URL}${apiRoutes.auth.google}`;
    };

    return (
        <div className="container">
            <form onSubmit={handleSubmit}>
                <h1>Register</h1>
                <div>
                    <input
                        type="text"
                        name="username"
                        placeholder="Username"
                        value={formData.username}
                        onChange={handleChange}
                    />
                </div>
                <div>
                    <input
                        type="email"
                        name="email"
                        placeholder="Email"
                        value={formData.email}
                        onChange={handleChange}
                    />
                </div>
                <div>
                    <input
                        type="password"
                        name="password"
                        placeholder="Password"
                        value={formData.password}
                        onChange={handleChange}
                    />
                </div>
                {errorMessage && <div style={{ color: "red" }}>{errorMessage}</div>}
                {successMessage && <div className="success-message">{successMessage}</div>}
                <button type="submit">Register</button>
            </form>
            <div>
                <h2> </h2>
                <button onClick={handleGoogleLogin} disabled={!isGoogleAuthEnabled}>
                    Register with Google
                </button>
            </div>
        </div>
    );
};

export default Register;
